import styled from 'styled-components';

export const AppWrapper = styled.div`
    width: 77vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 120px;
`

